export default "__VITE_ASSET__BfTI2sm1__"